/** @format */

// import Landing from "../landing/Landing";
import UserList from "../user/UserList";
// import Poll from "../poll/Poll";
import News from "../news/News";
import Channel from "../channel/Channel";
import Notification from "../notification/Notification";
import Syndication from "../syndication/Syndication";
import Home from "../home/home";
import Questionnaires from "../Risk assesment/Questionnaires";
import Questionnaire from "../Risk assesment/Questionnaire";
import AddAssessment from "../Risk assesment/AddAssessment";
import PollResults from "../Risk assesment/PollResults";
import AddPoll from "../poll/AddPoll";
import EditPoll from "../poll/EditPoll";
import Reports from "../reports/reports";
import Survey from "../survey/Survey";
import UserMapping from "../user_mapping/userMapping";
import homeIcon from "../../assets/Home.svg";
import newsIcon from "../../assets/News.svg";
import notificationIcon from "../../assets/Notification.svg";
import usersIcon from "../../assets/Users.svg";
import reportsIcon from "../../assets/Reports.svg";
import wtgIcon from "../../assets/Wtg.svg";
import syndicationIcon from "../../assets/Syndication.svg";
import pollIcon from "../../assets/Poll.svg";
import userMappingIcon from "../../assets/User_Mapping.svg";
import channelIcon from "../../assets/Channel.svg";
import surveyIcon from "../../assets/Survey.svg";
import { ROLES, GROUPS, SYNDICATION_ROLES } from "../../hooks/useRoles";
export const pagesList = [
  {
    label: "Home",
    icon: homeIcon,
    pageLink: "",
    view: Home,
    isExact: true,
    roles: (groups) => true,
    permissions: (groups) => {
      return groups.includes(GROUPS.INTERNAL_ADMIN) || groups.includes(GROUPS.USER_ADMIN);
    },
  },
  {
    label: "News",
    icon: newsIcon,
    pageLink: "news/*",
    view: News,
    isExact: true,
    roles: (groups) => true,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  {
    label: "Reports",
    icon: reportsIcon,
    pageLink: "reports",
    view: Reports,
    isExact: true,
    roles: (groups) => false, // groups.includes(GROUPS.INTERNAL_ADMIN),
    permissions: (groups) => false, // groups.includes(GROUPS.INTERNAL_ADMIN),
  },

  {
    label: "Syndication",
    icon: syndicationIcon,
    pageLink: "syndication",
    view: Syndication,
    isExact: true,
    roles: (groups) => true,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  // { label: "Poll", icon: pollIcon, pageLink: "poll", view: Pol, roles: groups => true, permissions: groups => groups},
  {
    label: "Risk Assessment",
    icon: pollIcon,
    pageLink: "Questionnaires",
    view: Questionnaires,
    isExact: true,
    roles: (groups) => false,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  {
    label: "Users",
    icon: usersIcon,
    pageLink: "users",
    view: UserList,
    isExact: true,
    roles: (groups) => true,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  {
    label: "User Mapping",
    icon: userMappingIcon,
    pageLink: "user-mapping",
    view: UserMapping,
    isExact: true,
    roles: (groups) => false,
    permissions: (groups) => groups,
  },
  {
    label: "Channel",
    icon: channelIcon,
    pageLink: "channel/*",
    view: Channel,
    isExact: false,
    roles: (groups) => true,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  {
    label: "Notification",
    icon: notificationIcon,
    pageLink: "notification",
    view: Notification,
    isExact: true,
    roles: (groups) => true,
    permissions: (groups) => {
      return (
        groups.includes(GROUPS.INTERNAL_ADMIN) ||
        (!groups.includes(GROUPS.INTERNAL_ADMIN) &&
          groups.includes(GROUPS.USER_ADMIN) &&
          SYNDICATION_ROLES.some((role) => groups.includes(role)))
      );
    },
  },
  {
    label: "Survey",
    icon: surveyIcon,
    pageLink: "survey/*",
    view: Survey,
    isExact: false,
    roles: (groups) => groups,
    permissions: (groups) => groups,
  },
];
export const AdditionPages = [
  { pageLink: "/createPoll", view: AddPoll, roles: (groups) => true, permissions: (groups) => groups, isExact: true },
  { pageLink: "/editpoll", view: EditPoll, roles: (groups) => true, permissions: (groups) => groups, isExact: true },
  {
    pageLink: "/Questionnaires/:id",
    view: Questionnaire,
    roles: (groups) => true,
    permissions: (groups) => groups,
    isExact: true,
  },
  {
    pageLink: "/createAssessment",
    view: AddAssessment,
    roles: (groups) => true,
    permissions: (groups) => groups,
    isExact: true,
  },
  {
    pageLink: "/pollResults",
    view: PollResults,
    roles: (groups) => true,
    permissions: (groups) => groups,
    isExact: true,
  },
];
